module.exports = __webpack_public_path__ + "static/img/stay-option-icon-pickupi.2101efbd.svg";